import React from 'react';

const Sessions = () => {
    return <div>Sessions</div>;
};

export default Sessions;
